import {CartData} from "./CartProcessor";
import {countText} from "./countText";
import {cartItemCount, cartSubtotal} from "./cartSummary";

/**
 * The line "In your cart: N items · Subtotal X" the format dialogs show.
 *
 * The texts come from the data attributes of the element, so the script
 * does not need translations of its own; data-template-one is the text for
 * one item.
 */
export class CartFeedback {
    static SELECTOR = '.eventgallery-cart-feedback';

    static update(root: ParentNode, data: CartData | null) {
        const box: HTMLElement = root.querySelector(CartFeedback.SELECTOR);
        if (!box || !data) {
            return;
        }
        const text: HTMLElement = box.querySelector('.cart-feedback-text');
        if (!text) {
            return;
        }

        text.textContent = CartFeedback.text(box, data);
    }

    /**
     * The sentence for a cart, from the templates of an element (data-template,
     * data-template-one, data-empty): the line of the format dialogs and the
     * live region of the mini cart say the same words.
     */
    static text(box: Element, data: CartData): string {
        const count = cartItemCount(data);
        const subtotal = cartSubtotal(data);

        return count > 0
            ? countText(box, 'data-template', count).replace('{subtotal}', subtotal)
            : box.getAttribute('data-empty') || '';
    }
}
